module.exports = __webpack_public_path__ + "res/img/order_on.9c7941b2.gif";